import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {FileManagementService} from '../../../service/file-manager.service';
import {TranslateService} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, MatSnackBar, MatSort} from '@angular/material';
import {MapService} from '../../../commons/map.service';
import {EPSGCodes, FourDService} from '4d-mapper';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from '../../../commons/app.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {Subject} from 'rxjs/Subject';
import {Subscription} from 'rxjs/index';
import {debounceTime} from 'rxjs/operators';


@Component({
  selector: 'app-epsgcode',
  templateUrl: './epsgcode-dialog.component.html',
  styleUrls: ['./epsgcode-dialog.component.scss']
})
export class EpsgcodeDialog implements OnInit, OnDestroy, AfterViewInit {

  searchEPSGControll = new FormControl();
  private selectedOption: any;
  options: any[] = [];

  displayedColumns: string[] = ['name', 'epsg'];
  datas: EPSGCodes[] = [];

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;
  searchStrChange: Subject<any> = new Subject<any>();
  searchStr: string;
  subs: Subscription[] = []
  selectedRowIndex: number = -1;
  selectedEPSGCode: any;

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private ar: ActivatedRoute, private t: TranslateService, private trans: TranslateService
    , private fb: FormBuilder, private cd: ChangeDetectorRef, private fileManager: FileManagementService, public dialogRef: MatDialogRef<EpsgcodeDialog>, public snackBar: MatSnackBar,
              private mapService: MapService, @Inject(MAT_DIALOG_DATA) public data, private httpClient: HttpClient) {
    // super(service, r, sn, d);
  }

  onRowClicked(row) {
    // console.log('Row clicked: ', row);
    this.selectedRowIndex = row.id;
    this.selectedEPSGCode = row;

  }


  ngOnInit() {
    this.searchEPSGControll.valueChanges.pipe(debounceTime(1000)).subscribe(s => {
      this.searchStr = s;
      this.paginator.pageIndex = 0;
      this.searchStrChange.next();
    });

  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.subs.push(this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0));
    this.subs.push(merge(this.sort.sortChange, this.paginator.page, this.searchStrChange)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.onInputChanged();
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(datas => {
        this.selectedRowIndex = -1;
        this.datas = datas;
      }));

      if ( this.data.incoming ) {
        setTimeout ( ()=>{ this.searchEPSGControll.setValue ( this.data.incoming ) }, 200);
      }
  }

  onInputChanged(): Observable<any> {
    let search = this.fourD.V.searchByObject(EPSGCodes)
      .sortBy(this.sort.active, this.sort.direction === 'desc' ? true : false)
      .offset(this.paginator.pageIndex * this.paginator.pageSize)
      .limit(this.paginator.pageSize);
      // .notEquals('desc', ''); // filter out the desc == null
    if (this.searchStr) {
      return search.contains('name', this.searchStr).queryObservable();
    } else {
      return search.queryObservable();
    }

  }

  setDefaultEPSGCode() {
    this.fourD.V.searchByObject(EPSGCodes).equals('uid', '4326').queryObservable().subscribe(value => {
      this.dialogRef.close(value.items[0]);
    });
  }


  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}

